import { render } from "./KatExUpdaterDownload.vue?vue&type=template&id=282f96f0&scoped=true"
import script from "./KatExUpdaterDownload.vue?vue&type=script&lang=js"
export * from "./KatExUpdaterDownload.vue?vue&type=script&lang=js"

import "./KatExUpdaterDownload.vue?vue&type=style&index=0&id=282f96f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282f96f0"]])

export default __exports__